<template>
    <section class="seoBox" id="seoBox">
        <div class="container">
            <h2>【母親節禮物選禮指南】限時優惠！PChome 24h 購物指定支付享高額回饋！</h2>
            <p class="mb-5">
                PChome星展聯名卡，玉山、台新；國泰等36家銀行優惠，與Pi錢包綁定Pi卡再享高額回饋，
                讓您盡情享受輕鬆購物的極致樂趣！越買越省，買越多回饋越多。
            </p>
            
            <h2>「進站領$520犒賞券」、「寵愛戳戳樂拿520P幣」，與「天天簽到送P幣」通通送給您！</h2>
            <p class="mb-5">
                母親節最懂媽媽心！PChome祭出母親節禮物選禮指南，網路人氣熱議聲量排行，不用再猶豫要送什麼母親節禮物。
                天天瘋狂搶優惠，最優惠價格保證！進站搶獨家犒賞券指定品限時折$520；週四、週末、5/7加碼日，
                多檔P幣加碼限時回饋最高10%P幣；簽到免費領P幣，再玩寵愛戳戳樂遊戲最高拿520P幣；指定商品、
                購物滿額還有各種獨家好禮與優惠回饋。讓你每天到PChome24h都是一場驚喜旅程，買的更開心，玩得更開心。
            </p>
            
            <h2>【選禮指南、24H送禮推薦、萬能媽咪主題專區、14大品類分會場等活動齊聚登場！</h2>
            <p class="mb-5">
                各種品類齊全商品，專櫃保養、智能家電、百搭時尚、美食餐券等各種媽咪願望推薦清單等你挑。
                 忘記買母親節禮物別擔心，「媽咪願望清單」、「24H送禮專區」等快速完成寵愛媽媽的貼心任務，
                 搭配指定限時回饋優惠，讓你聰明購物無負擔！快來「PChome 24h 購物」，輕鬆準備禮物，
                 還有超值人氣餐廳即享券，讓媽媽過個難忘的母親節。
            </p>       
        </div>
    </section>
</template>

<script>
export default {
    name: 'seoTemplate',
}
</script>


<style lang="scss" scoped>
.seoBox {
    padding: 1rem 0 3rem 5rem;
    overflow: hidden;
    color: #fff;
    /* background-color: #ffdccf; */
    @media only screen and (max-width: 991px) {
        padding: 1rem 0 2rem;
    }
    @media only screen and (max-width: 767px) {
        padding: 4rem 0 7rem;
    }
    p {
        font-weight: 400;
    }
    @media only screen and (max-width: 991px) {
        h2 {
            font-size: 16px;
            font-weight: 600;
        }
        p {
            font-size: 13px;
        }
    }

}
</style>
